module.exports = __webpack_public_path__ + "static/media/multiverse5.04ac6170.png";